module.exports = __webpack_public_path__ + "img/3M.9c71785d.png";